import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagOrdersByVendor",
    title: "Auto Tag Orders By Vendor",
    description: "Automatically add tags to orders that correspond to the vendor of each purchased product.",
    example: "If a product with vendor MyVendor is purchased, a tag MyVendor will be added to the order.",
    additional: [
        "You can specify prefix, capitalization, and spacing settings for tags",
    ],
    legacy: false,
    inProgress: false,
    previewType: "OrderTags",
    dataPermissions: ["products", "customers", "orders"],
    allowPreview: false,
    tags: ["Orders", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagOrdersByVendor",
                tagTemplate: {
                    prefix: null,
                    casingTransformation: "KeepOriginal",
                    spacesTransformation: "KeepSpaces",
                }
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.tagTemplate.casingTransformation == null || rule.settings.tagTemplate.casingTransformation === "") {
                        errors["casingTransformation"] = "Casing value is required";
                    }

                    if (rule.settings.tagTemplate.spacesTransformation == null || rule.settings.tagTemplate.spacesTransformation === "") {
                        errors["spacesTransformation"] = "Spaces value is required";
                    }
                }
            ], null);
    }
};

export default ruleDefinition;